<template>
  <tr v-if="item">
    <h4 v-show="false">{{rerender}}</h4>
    <td>
      {{item.name}}
    </td>
    <td>{{item.collector_version ||  '-'}}</td>
    <td>
      <template v-if="item.intervals">
        {{item.intervals}}s
        <v-btn icon @click.stop="$emit('openEditInterval', item)">
          <v-icon class="muted--white">edit</v-icon>
        </v-btn>
      </template>
      <template v-else>
        N/A
      </template>
    </td>
    <td>
      <span class="status" :class="getStatusClass(item.status)">{{item.intervals ? item.status : 'Unknown'}}</span>
    </td>
    <td>
      <span>{{item.cluster_status ? item.cluster_status : 'N/A'}}</span>
    </td>
    <td>
      <span v-if="item.old_incoming_count && item.incoming_count !=  item.old_incoming_count || item.old_content_count && item.content_count !=  item.content_count">
        Scaling
      </span>
      <span v-else>
        <span v-if="!item.cluster_status || item.cluster_status == 'Stopped' || item.cluster_status == 'Unknown'">
          N/A
        </span>
        <span v-else>
          <span v-if="item.incoming_count && item.content_count">{{ item.incoming_count }}/{{ item.content_count }}</span>
          <span v-else-if="item.incoming_count || item.content_count">{{ item.incoming_count || '-' }}/{{ item.content_count  || '-' }}</span>
          <span v-else>N/A</span>
        </span>
      </span>
    </td>
    <td>
      <div v-if="editCluster" class="d-flex justify-space-between">
        <v-menu max-width="340px" nudge-width="340px" offset-y left>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              class="white-bg"
              dark
              v-on="on"
            >
              <v-icon color="#2E2B3F">more_horiz</v-icon>
            </v-btn>
          </template>
          <v-list class="api-key-edit">
            <v-list-item
              :key="'processing_cluster_item_1'"
               @click="$emit('openEditDialog', item)"
            >
              <i class="pe-7s-edit fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_2'"
              @click="$emit('openEditInterval', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Change Polling Interval</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_3'"
              @click="$emit('openUpdateItemDialog', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Update</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_4'"
              @click="$emit('openLogs', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Logs</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_5'"
              @click="$emit('openStartStopClusterDialog', {item, start: true})"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Start Cluster</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_6'"
              @click="$emit('openStartStopClusterDialog', {item, start: false})"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Stop Cluster</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_9'"
              @click="$emit('openSetUpSSL', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Setup SSL</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_7'"
              @click="$emit('openScaleCluster', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Scale Cluster</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="'processing_cluster_item_8'"
              @click="$emit('openDeleteItemDialog', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProcessingClusterItem',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      rerender: false
    }
  },
  computed: {
    ...mapGetters(['license', 'currentOrganization']),
    editCluster () {
      return this.currentOrganization.partner !== 'msp_client'
    }
  },
  methods: {
    getStatusClass (status) {
      let className = 'grey'
      if (!status) {
        return className
      }
      switch (status.toLocaleLowerCase()) {
        case 'active':
          className = 'ok'
          break
        case 'warning':
          className = 'warning'
          break
        case 'offline':
          className = 'error'
          break
      }
      return className
    },
    scanText () {
      try {
        return this.license.description === 'free' ? 'Sample Scan' : 'Scan'
      } catch (error) {
        this.$store.dispatch('fetchOrganizationLicense', this.currentOrganization.entity_id)
          .then(() => {
            this.rerender = !this.rerender
          })
      }
      return 'Sample Scan'
    }
  }
}
</script>

<style scoped>
   .grey {
      background-color: #BDC9D0 !important;
      border-color: #BDC9D0 !important;
   }
</style>
